const version = '0.1.66';

export default version;
